import { cn } from '../../lib/utils';

export interface SpinnerProps {
  animate?: boolean;
  size?: number;
  className?: string;
}

export function Spinner({ animate = false, size = 100, className }: SpinnerProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      aria-hidden="true"
      focusable="false"
      role="img"
      className={cn('shrink-0', animate && 'animate-spin', className)}
    >
      <path
        d="M57.2942 0.535044C63.5286 1.45437 69.5331 3.54397 74.9913 6.69378L69.993 15.3551C65.6265 12.8352 60.8229 11.1635 55.8354 10.4281L57.2942 0.535044Z"
        fill="#F4F4F4"
      />
      <path
        d="M75.0001 6.69887C85.7788 12.922 93.8491 22.9414 97.6332 34.7985C101.417 46.6555 100.643 59.4976 95.4619 70.8142C90.2808 82.1307 81.0653 91.1081 69.617 95.9912C58.1687 100.874 45.3107 101.312 33.5568 97.219C21.8029 93.1258 11.9981 84.796 6.05925 73.8581C0.120419 62.9201 -1.52546 50.1604 1.44337 38.0735C4.41221 25.9865 11.7823 15.4414 22.1128 8.49954C32.4433 1.55772 44.9915 -1.28165 57.3042 0.536525L55.8434 10.4292C45.9932 8.97471 35.9547 11.2462 27.6903 16.7997C19.4259 22.3531 13.5298 30.7893 11.1547 40.4588C8.77965 50.1284 10.0964 60.3361 14.8474 69.0865C19.5985 77.8369 27.4423 84.5007 36.8454 87.7752C46.2486 91.0497 56.5349 90.6995 65.6936 86.793C74.8522 82.8865 82.2246 75.7046 86.3695 66.6514C90.5144 57.5981 91.1338 47.3244 88.1065 37.8388C85.0793 28.3532 78.6231 20.3376 70.0001 15.3591L75.0001 6.69887Z"
        fill="#F4F4F4"
      />
      <path
        d="M2.65201 66.0676C-0.129824 57.8701 -0.735691 49.0907 0.8937 40.5888C2.52309 32.0869 6.33191 24.1536 11.9474 17.5655C17.5629 10.9773 24.7927 5.95993 32.9292 3.00441C41.0657 0.0488789 49.8301 -0.743549 58.3648 0.704673L56.6918 10.5637C49.8641 9.40516 42.8525 10.0391 36.3433 12.4035C29.8341 14.7679 24.0503 18.7818 19.5579 24.0524C15.0655 29.3229 12.0185 35.6695 10.715 42.4711C9.41145 49.2726 9.89614 56.2961 12.1216 62.8541L2.65201 66.0676Z"
        fill="#D9D9D9"
      />
    </svg>
  );
}
